import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { MatsterApiService, SupplierResponse } from 'features/master/api/master-api.service';
import { UserListParams } from 'features/users';
import qs from 'qs';

import { MaterQueryKeys } from './query-keys';

const { getMatrials } = MatsterApiService();

const getUsersQuery = (
  params: UserListParams,
  options?: UseQueryOptions<SupplierResponse>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<SupplierResponse>;
  options?: UseQueryOptions<SupplierResponse>;
} => ({
  queryKey: MaterQueryKeys.list(params),
  queryFn: ({ signal }) =>
    getMatrials(params, {
      config: {
        signal,
        paramsSerializer: {
          serialize: (queryParams) =>
            qs.stringify(queryParams, {
              arrayFormat: 'repeat',
              encode: true,
            }),
        },
      },
    }),
  ...options,
});

export const useGetMatrialList = (
  params: UserListParams,
  options?: UseQueryOptions<SupplierResponse>,
) => {
  const { message } = App.useApp();
     
  return useQuery<SupplierResponse, Error>(
    getUsersQuery(params, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    }),
  );
};








